.overlay {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-7);
  background: var(--overlay);
}

.panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 2 * var(--sp-8));
  background: var(--surface);
  -webkit-backdrop-filter: var(--glass-blur);
  backdrop-filter: var(--glass-blur);
  border-radius: var(--radius-lg);
  box-shadow: var(--glass-rim), var(--shadow-modal);
}

.panel.wide {
  max-width: 680px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  padding: var(--sp-5) var(--sp-6);
  border-bottom: 1px solid var(--border);
}

.title {
  margin: 0;
  font-size: var(--fs-lg);
  font-weight: 600;
}

.closeBtn {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: var(--bw) solid transparent;
  border-radius: var(--radius);
  color: var(--text-2);
  font-size: var(--fs-lg);
  line-height: 1;
  cursor: pointer;
}

.closeBtn:hover {
  background: var(--surface-2);
}

.body {
  overflow-y: auto;
  padding: var(--sp-6);
}

.fallback {
  color: var(--text-2);
  font-size: var(--fs-md);
}
